export const StarEmpty = ({ width = 20 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 79 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title id="starEmptyTitle">Star Empty</title>
      <desc id="starEmptyDesc">Star Empty Icon</desc>
      <path
        d="M39.5 0L48.5928 22.1115H78.0178L54.2125 35.7771L63.3053 57.8885L39.5 44.2229L15.6947 57.8885L24.7875 35.7771L0.982212 22.1115H30.4072L39.5 0Z"
        fill="#D9D9D9"
        stroke="#131212"
        strokeWidth="2"
      />
    </svg>
  );
};
